import { get, post } from '@/utils/http'
import { API } from './constants'

// 登录方法
export function login(data) {
  return post(API.USER.Login, data)
}

// 获取用户信息
export function getInfo() {
  return get(API.USER.INFO)
}

// 退出方法
export function logout() {
  return post(API.USER.Logout)
}
